import { useEffect, useState } from "react";
import NewNavbar from "./NewNavbar";
import Footer from "./Footer";
import axios from "axios";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import toast, { Toaster } from "react-hot-toast";

export default function AquaMonitoring() {
  const [fade, setFade] = useState(true);

  const images = [
    {
      id: 1,
      imageUrl:
        "https://res.cloudinary.com/dt8emxboh/image/upload/v1774854696/gh5ds5gckyp6bdgf3mj1.png",
    },
    {
      id: 2,
      imageUrl:
        "https://res.cloudinary.com/dt8emxboh/image/upload/v1774854727/k5tgt8dvspz8k1qtzdmo.png",
    },
    {
      id: 3,
      imageUrl:
        "https://res.cloudinary.com/dt8emxboh/image/upload/v1774854746/df5w4yphtlgnfqwkzg2r.png",
    },
  ];

  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 2000);

    return () => clearInterval(interval);
  }, []);

  //Book a Demo call api

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // ✅ Phone validation
    if (!/^\d{10}$/.test(formData.phone)) {
      toast.error("Phone number must be exactly 10 digits");
      return;
    }

    try {
      await axios.post("https://api.livestockify.com/api/admin/queries", {
        name: formData.firstName + " " + formData.lastName,
        phone: formData.phone,
        email: formData.email,
        message: formData.message,
      });

      toast.success("Message sent successfully ✅");

      // reset form
      setFormData({
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error(error);
      toast.error("Something went wrong ❌");
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % images.length);
        setFade(true);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <NewNavbar />
      <Toaster position="top-right" reverseOrder={false} />

      <Carousel
        showThumbs={false}
        infiniteLoop={true}
        autoPlay={true}
        interval={3000}
        stopOnHover={true}
        dynamicHeight={true}
        showStatus={false}
        transitionTime={600}
        emulateTouch={true}
        swipeable={true}
        className="h-full"
      >
        {images.map((image) => (
          <div
            key={image.id}
            className="relative w-full h-[2x30px] md:h-[420px] lg:h-[550px] xl:h-[800px] 2xl:h-[850px]"
          >
            <img
              src={image.imageUrl}
              className="w-full h-full object-cover"
              alt={image.description || "carousel image"}
            />
          </div>
        ))}
      </Carousel>
      {/* </section> */}

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-7xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800">
              Our <span className="text-[#6FAF1E]">Offerings</span> for Smart
              Aqua-Monitoring <span className="text-[#0F6D73]">Solutions</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Kuppismart provides specialised IoT devices that monitor, analyse,
              and automate critical environmental and farming parameters. From
              aquaculture water quality to gas and treatment systems, our
              solutions ensure continuous visibility, timely alerts, and
              reliable control.
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid md:grid-cols-2 gap-16 mt-16 items-start">
            {/* Product 1 */}
            <div className="text-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773232753/otntqnbt6dlij4efgz7l.png"
                alt="AquaSense Pro"
                className="mx-auto w-64 md:w-72"
              />

              <h3 className="text-4xl font-bold mr-20 text-[#6FAF1E] mt-8">
                Kuppismart AquaSense Pro
              </h3>

              <div className="grid grid-cols-2 gap-6 text-left mt-6 text-sm text-gray-700">
                <div>
                  <h2 className="font-semibold text-[#0F6D73]">
                    Sensors Supported:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Dissolved Oxygen (DO)</li>
                    <li>Water Temperature</li>
                    <li>pH</li>
                    <li>Ammonia</li>
                    <li>ORP</li>
                    <li>Expandable sensor ports</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Monitoring:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Multi-pond monitoring</li>
                    <li>Real-time analytics dashboard</li>
                    <li>Historical trends</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Connectivity:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Wi-Fi / Cellular (4G)</li>
                    <li>Cloud data logging</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">Alerts:</h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>App / SMS / WhatsApp</li>
                    <li>Threshold alerts</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-semibold text-[#0F6D73]">Power:</h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>AC power</li>
                    <li>Solar-ready with battery backup</li>
                    <li>Low-power operation</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Automation:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Aerator automation</li>
                    <li>Pump / feeder integration</li>
                    <li>Rule-based automation</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Deployment:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Multi-pond farms</li>
                    <li>Commercial aquaculture</li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Product 2 */}
            <div className="text-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773232816/mvkhkrrkvtwfgf7sthvo.png"
                alt="AquaSense"
                className="mx-auto w-64 md:w-80"
              />

              <h3 className="text-4xl mr-20 font-bold text-[#6FAF1E] mt-8">
                Kuppismart AquaSense
              </h3>

              <div className="grid grid-cols-2 gap-6 text-left mt-6 text-sm text-gray-700">
                <div>
                  <h2 className="font-semibold text-[#0F6D73]">
                    Sensors Supported:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Dissolved Oxygen (DO)</li>
                    <li>Water Temperature</li>
                    <li>pH</li>
                    <li>Optional Ammonia / ORP</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Monitoring:
                  </h2>
                  <ul className="list-disc font-semibold ml-4 mt-1">
                    <li>Real-time pond tracking</li>
                    <li>Mobile dashboard</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Connectivity:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Wi-Fi / Cellular (4G)</li>
                    <li>Cloud data logging</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">Alerts:</h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>App notifications</li>
                    <li>SMS / WhatsApp alerts</li>
                  </ul>
                </div>

                <div>
                  <h2 className="font-semibold text-[#0F6D73]">Power:</h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>AC power</li>
                    <li>Solar compatible</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Automation:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Alert-based manual control</li>
                  </ul>

                  <h2 className="font-semibold text-[#0F6D73] mt-4">
                    Deployment:
                  </h2>
                  <ul className="list-disc ml-4 font-semibold mt-1">
                    <li>Single pond monitoring</li>
                    <li>Small to medium farms</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Key <span className="text-[#6FAF1E]">Aquaculture Solutions</span>{" "}
              Powered by <span className="text-[#0F6D73]">Kuppismart</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Kuppismart aquaculture devices deliver multi-parameter water
              quality sensing, real-time mobile app monitoring with instant
              alerts, solar-backed reliability, and automation with existing
              aerators and farm equipment.
            </p>
          </div>

          {/* Section 1 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-16">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Real-Time</span> App Alerts &
                Monitoring
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Live pond data is transmitted to the Kuppismart mobile app with
                instant alerts whenever conditions deviate from safe ranges,
                enabling farmers to take immediate action from anywhere.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1772726888/ahj0tsfyafvyu027e0ih.png"
                alt="Mobile Monitoring App"
                className="w-[220px] md:w-[280px] lg:w-[320px]"
              />
            </div>
          </div>

          {/* Section 2 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Image */}
            <div className="flex justify-center order-2 md:order-1">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1774862199/ihenkigwhkdzllavbw43.png"
                alt="Aerator Automation"
                className="w-[360px] md:w-[320px] lg:w-[380px]"
              />
            </div>

            {/* Text */}
            <div className="text-center md:text-left order-1 md:order-2">
              <h3 className="text-xl md:text-2xl font-semibold">
                Aerator & Farm Equipment{" "}
                <span className="text-[#6FAF1E]">Automation</span>
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Seamlessly integrates with existing aerators and pond equipment
                to automatically respond to changing water conditions —
                optimizing oxygen levels, reducing manual intervention, and
                improving farm efficiency.
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div className="grid md:grid-cols-2 gap-12 items-center mt-20">
            {/* Text */}
            <div className="text-center md:text-left">
              <h3 className="text-xl md:text-2xl font-semibold">
                <span className="text-[#6FAF1E]">Solar-Powered</span>{" "}
                Reliability
              </h3>

              <p className="text-gray-600 mt-3 text-sm md:text-base">
                Built with solar backup capability, Kuppismart devices ensure
                uninterrupted pond monitoring even in remote farm locations or
                during power outages.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center">
              <img
                src="http://res.cloudinary.com/dt8emxboh/image/upload/v1773232816/mvkhkrrkvtwfgf7sthvo.png"
                alt="Solar Powered Device"
                className="w-[260px] md:w-[320px] lg:w-[360px]"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6">
          {/* Heading */}
          <div className="text-center max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-4xl font-bold">
              Why Choose <span className="text-[#6FAF1E]">Aqua Sense</span>
            </h2>

            <p className="text-gray-600 mt-4 text-sm md:text-base">
              Unlike generic aquaculture monitoring devices, Aqua Sense and Aqua
              Sense Pro combine advanced water sensing, expandable parameters,
              solar-powered operation, and automated aerator control—helping
              farms achieve stable pond conditions and scalable monitoring.
            </p>
          </div>

          {/* Table */}
          <div className="mt-14 overflow-x-auto">
            <table className="w-full min-w-[900px] border-collapse">
              {/* Table Head */}
              <thead>
                <tr className="text-center">
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Feature
                  </th>
                  <th className="py-4 text-[#6FAF1E] text-2xl font-semibold">
                    Aqua Sense Pro
                  </th>
                  <th className="py-4 text-[#0F6D73] text-2xl font-semibold">
                    Aqua Sense
                  </th>
                  <th className="py-4 text-gray-700 text-2xl font-semibold">
                    Typical Other System
                  </th>
                </tr>
              </thead>

              {/* Table Body */}
              <tbody className="text-sm md:text-base">
                <tr className="">
                  <td className="py-4 text-xl font-medium">Water Parameters</td>
                  <td className="text-[#6FAF1E] text-xl">DO, Temp, pH</td>
                  <td className="text-[#0F6D73] text-xl">
                    DO, Temp, pH, Ammonia, ORP
                  </td>
                  <td className="text-xl">DO, Temp, pH, Ammonia</td>
                </tr>

                <tr className="">
                  <td className="py-4 font-medium text-xl">
                    Expandable Water Parameters
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Limited</td>
                  <td className="text-[#0F6D73] text-xl">
                    ✔ Modular expansion
                  </td>
                  <td className="text-xl">✖ Fixed sensors</td>
                </tr>

                <tr className="">
                  <td className="py-4 font-medium text-xl">
                    Real-Time Monitoring
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                </tr>

                <tr className="">
                  <td className="py-4 font-medium text-xl">
                    Mobile App Alerts
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Cloud Dashboard</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Solar Power Support
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Automation (Aerator / Pump)
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Manual assist</td>
                  <td className="text-[#0F6D73] text-xl">
                    ✔ Automatic control
                  </td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Multi-Pond Support
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Single pond</td>
                  <td className="text-[#0F6D73] text-xl">✔ Multi-pond</td>
                  <td className="text-xl">Limited</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Sensor Expansion Ports
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Limited</td>
                  <td className="text-[#0F6D73] text-xl">✔ Multiple</td>
                  <td className="text-xl">Fixed</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Connectivity</td>
                  <td className="text-[#6FAF1E] text-xl">Wi-Fi / 4G</td>
                  <td className="text-[#0F6D73]text-xl">Wi-Fi / 4G / LoRa</td>
                  <td className="text-xl">Wi-Fi / LoRa</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Installation</td>
                  <td className="text-[#6FAF1E] text-xl">Plug-and-deploy</td>
                  <td className="text-[#0F6D73] text-xl">
                    Farm-wide deployment
                  </td>
                  <td className="text-xl">Moderate</td>
                </tr>

                <tr className="">
                  <td className="py-4  text-xl font-medium">
                    Designed for Shrimp Farms
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">Generic aquaculture</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">
                    Automation Intelligence
                  </td>
                  <td className="text-[#6FAF1E] text-xl">Alerts-based</td>
                  <td className="text-[#0F6D73] text-xl">
                    Rule-based automation
                  </td>
                  <td className="text-xl">Minimal</td>
                </tr>

                <tr className="">
                  <td className="py-4 text-xl font-medium">Farm Scalability</td>
                  <td className="text-[#6FAF1E] text-xl">Small–medium</td>
                  <td className="text-[#0F6D73] text-xl">Medium–large</td>
                  <td className="text-xl">Medium</td>
                </tr>

                <tr>
                  <td className="py-4 text-xl font-medium">
                    Integration with Existing Equipment
                  </td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">✔</td>
                  <td className="text-xl">Partial</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* ================= BOOK DEMO SECTION ================= */}
        <section className="py-20 bg-[#F8FAF6]">
        <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center md:text-left">
            <h2 className="text-4xl md:text-5xl font-bold">
              Book a <span className="text-[#6FAF1E]">Demo</span> Today
            </h2>

            <p className="text-gray-600 mt-6 text-lg max-w-md mx-auto md:mx-0">
              Book a Demo today to discover how Kuppismart can optimise your
              farm with IoT and AI technologies.
            </p>
          </div>

          {/* Form Card */}
          <div className="bg-white p-8 rounded-xl shadow-md">
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    First Name
                  </label>
                 

                  <input
                    type="text"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    placeholder="Enter Your First Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Last Name
                  </label>
                

                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Enter Your Last Name"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Contact Row */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-start font-medium mb-1">
                    Phone Number
                  </label>
                 

                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="Enter Your Phone Number"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>

                <div>
                  <label className="block text-start font-medium mb-1">
                    Email-ID
                  </label>
                

                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter Your Email-ID"
                    required
                    className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                  />
                </div>
              </div>

              {/* Message */}
              <div>
                <label className="block text-start font-medium mb-1">
                  How can we help you?
                </label>
            

                <textarea
                  rows="4"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Enter Your Message"
                  required
                  className="w-full border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
                />
              </div>

              {/* Button */}
              <button
                type="submit"
                className="w-full bg-green-600 text-white py-3 rounded-md font-medium hover:bg-green-700 transition"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}
